var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 89,
    viewBox: "0 0 160 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.521 87.251C106.159 79.8786 26.7748 34.8516 4.32208 23.3506C2.80848 22.5784 1.58182 21.3299 0.825465 19.7918C0.069108 18.2536 -0.176333 16.5084 0.125828 14.8171C0.888784 10.5779 2.75984 5.21448 7.26491 2.02591C8.41774 1.22124 9.76165 0.743956 11.1574 0.643496C12.5532 0.543036 13.9501 0.823056 15.2033 1.45455L140.255 63.5303C140.747 63.7797 141.19 64.1169 141.563 64.5256L158.421 82.9566C158.846 83.421 159.126 84.002 159.228 84.6271C159.329 85.2522 159.247 85.8938 158.991 86.4717C158.735 87.0497 158.317 87.5384 157.789 87.8769C157.262 88.2155 156.647 88.3888 156.023 88.3753L130.591 87.7487C129.55 87.7243 128.518 87.5569 127.521 87.251Z",
    fill: "#FE6571"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.842 79.8779C152.898 80.9654 151.209 84.9465 150.845 87.5821",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.475 63.5845C132.135 70.6251 128.32 78.8822 129.065 86.439",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0932 3.5376C10.7707 7.44498 6.26564 15.7021 4.92139 22.2267",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.81e03835f0ba0419651bb7257fbc8926.svg";
export { ForwardRef as ReactComponent };